import { useHistory, useLocation } from 'react-router-dom';

import { useRiskRegisterStore } from 'store/riskRegister.store';
import { useThemeStatusStore } from 'store/themeStatus.store';

import { UseActivityLevelDriversProvider } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.provider';
import {
    PER_PAGE,
    exportCsvHeaders,
    options,
    series,
} from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.utils';

interface Props {
    api: UseActivityLevelDriversProvider['api'];
    ui: UseActivityLevelDriversProvider['ui'];
}

export const useActivityLevelDriversLogic = ({ api, ui }: Props) => {
    const { themeStatus } = useThemeStatusStore();
    const { taskVersionLabel, numOfIterations } = useRiskRegisterStore();
    const { pathname, search } = useLocation();
    const history = useHistory();

    const impactTypeData =
        api.activityLevelDrivers.data?.tornadoResponse?.find((item) => item.impactType === ui.state.impactType.value)
            ?.tornadoActivities ?? [];

    const totalRecords = api.activityLevelDrivers.data?.tornadoResponse?.[0].tornadoActivities ?? [];

    const totalPages = totalRecords ? Math.ceil(totalRecords.length / PER_PAGE) : 0;

    const dataPointSelection = ({ dataPointIndex }: { dataPointIndex: number }) => {
        const value = impactTypeData[dataPointIndex];
        history.push(`${pathname}/card-${value.taskId}-1${search}`);
    };

    const rowCount = impactTypeData.length;
    const pixelsPerRow = 100;
    const chartHeight = Math.max(400, rowCount * pixelsPerRow);

    return {
        logic: {
            series: series({ data: impactTypeData }),
            options: options({ data: impactTypeData, themeStatus, dataPointSelection }),
            chartHeight,
            totalPages,
            taskVersionLabel,
            numOfIterations,
            exportCsv: {
                headers: exportCsvHeaders({ impactType: ui.state.impactType }),
                rows: impactTypeData.map((row) => ({
                    activityId: row.activityId,
                    activityName: row.activityName,
                    impactValue: row.impactValue,
                    taskId: row.taskId,
                })),
                fileName: 'Activity-Level-Drivers',
            },
        },
    };
};
